// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-field-container.input-field input{width:100%}`, "",{"version":3,"sources":["webpack://./libs/ui-components/src/form/form-fields/input/input.scss"],"names":[],"mappings":"AACI,wCACI,UAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
